<template>
  <div>
    <Loader v-if="loading" />
    <div v-else>
      <template v-if="!viewMedFlag && loadFlag">
        <div class="sa-mob-header">
          <h5 class="sa-card-tit">Add Medicine</h5>
          <button class="sa-btn-back" @click="backAction">
            <i class="icon-arrow-left"></i>
          </button>
        </div>
        <ValidationObserver
            ref="form"
            tag="div"
            v-slot="{ handleSubmit }"
            @keyup.enter="handleSubmit(SaveDrug)"
          >
            <div class="sa-mob-cont sa-mob-cont-padbt">
            <div class="sa-row">
            <ValidationProvider
              class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg6"
              tag="div"
              rules="required"
              name="Scientific Name"
              v-slot="{ errors }"
            >
              <div class="sa-form-group suffix">
                <label>Scientific Name<span class="sa-red-text">*</span></label>
                <input
                  type="text"
                  id="fname"
                  v-model="drugObj.scientific_name"
                  name="fname" @click="scientific_check()"
                  class="sa-form-control sa-form-control-lg" readonly
                />
                <!-- <v-select
                  :options="scientifics"
                  :reduce="(c) => c.SNCODE"
                  label="SCIENTIFIC_NAME"
                  v-model="drugObj.sncode"
                  id="scientific_name"
                  name="Scientific_name"
                  class="sa-v-slct-lg"
                  ><span slot="no-options">No data</span></v-select
                > -->

                <i v-if="drugObj && drugObj.scientific_name" @click="removeScintific()" class="icon-cancel"></i>
                <span class="sa-val-err">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>

            <ValidationProvider
              class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg6"
              tag="div"
              rules="required"
              name="Trade Name"
              v-slot="{ errors }"
            >
              <div class="sa-form-group suffix">
                <label>Trade Name<span class="sa-red-text">*</span></label>

                <!-- <v-select
                  :options="drugs"
                  id="drug_Name"
                  name="Drug Name"
                  v-model="drugObj.drug_nm"
                  class="sa-v-slct-lg"
                  ><span slot="no-options">No data</span></v-select
                > -->
                <textarea
                  type="text"
                  class="sa-form-control sa-textarea-lg"
                  id="drug_Name"
                  name="Trade Name" @click="drugs_check()"
                  v-model="drugObj.drug_nm" readonly
                />

                <i v-if="drugObj && drugObj.drug_nm" @click="removeDrugName()" class="icon-cancel"></i>
                <span class="sa-val-err">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
            <ValidationProvider
              class="sa-col-xs12 sa-col-sm6 sa-col-md5 sa-col-lg4"
              tag="div"
              rules="required"
              name="Indications"
              v-slot="{ errors }"
            >
              <div class="sa-form-group">
                <label>Indications<span class="sa-red-text">*</span></label>
                <v-select
                  :options="assesment"
                  v-model="drugObj.indications"
                  id="indications"
                  name="Indications"
                  class="sa-v-slct-lg"
                  ><span slot="no-options">No data</span></v-select
                >
                <span class="sa-val-err">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
            <ValidationProvider
              class="sa-col-xs6 sa-col-sm6 sa-col-md3 sa-col-lg3"
              tag="div"
              rules="required"
              name="Route"
              v-slot="{ errors }"
            >
              <div class="sa-form-group">
                <label>Route<span class="sa-red-text">*</span></label>
                <input
                  type="text"
                  class="sa-form-control sa-form-control-lg"
                  id="dose"
                  name="Dose"
                  :disabled="!dflag"
                  v-model="drugObj.route"
                />
                <!-- <v-select :options="routes" v-model="drugObj.route" id="route" name="Route" class="sa-v-slct-lg"><span slot="no-options">No data</span></v-select>           -->
                <span class="sa-val-err">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
            
            <ValidationProvider
              class="sa-col-xs6 sa-col-sm6 sa-col-md3 sa-col-lg3"
              tag="div"
              rules="required"
              name="Dose Unit"
              v-slot="{ errors }"
            >
              <div class="sa-form-group sa-ellipsis-full">
                <label>Pharm<span class="sa-red-text">*</span></label>
                <input
                  type="text"
                  class="sa-form-control sa-form-control-lg"
                  id="pharm"
                  name="pharm"
                  :disabled="!dflag"
                  v-model="drugObj.pharm"
                />
                <!-- <v-select :options="doseUnits" v-model="drugObj.dose_unit" id="doseUnit" name="Dose Unit" class=" sa-v-slct-lg"><span slot="no-options">No data</span></v-select> -->
                <span class="sa-val-err">{{ errors[0] }}</span>
              </div>
            </ValidationProvider> 
            <ValidationProvider
              class="sa-col-xs6 sa-col-sm6 sa-col-md3 sa-col-lg3"
              tag="div"
              rules="required"
              name="Dose"
              v-slot="{ errors }"
            >
              <div class="sa-form-group">
                <label>Dose<span class="sa-red-text">*</span></label>
                <input
                  type="text"
                  class="sa-form-control sa-form-control-lg"
                  id="dose"
                  name="Dose"
                  v-model="drugObj.dose"
                />
                <span class="sa-val-err">{{ errors[0] || qcDailyError }}</span>
              </div>
            </ValidationProvider>
            <ValidationProvider
              class="sa-col-xs6 sa-col-sm6 sa-col-md3 sa-col-lg3"
              tag="div"
              rules="required"
              name="Dose Unit"
              v-slot="{ errors }"
            >
              <div class="sa-form-group sa-ellipsis-full">
                <label>Dose Unit<span class="sa-red-text">*</span></label>
                <!-- <input
                  type="text"
                  class="sa-form-control sa-form-control-lg"
                  id="dose"
                  name="Dose"
                  :disabled="!dflag"
                  v-model="drugObj.dose_unit"
                /> -->
                <v-select :options="doseUnits" v-model="drugObj.dose_unit" id="doseUnit" name="Dose Unit" class=" sa-v-slct-lg"><span slot="no-options">No data</span></v-select>
                <span class="sa-val-err">{{ errors[0] || (liveLimitCheck && liveLimitCheck.calcError) }}</span>
              </div>
            </ValidationProvider>
    <ValidationProvider
              class="sa-col-xs12 sa-col-sm6 sa-col-md5 sa-col-lg4"
              tag="div"
              :rules="{ required: true, maxQuantity: true }"
              name="Number of boxes"
              v-slot="{ errors }"
            >
              <div class="sa-form-group">
                <label>Number of boxes<span class="sa-red-text">*</span></label>
                <!-- <input
                  type="number"
                  class="sa-form-control sa-form-control-lg"
                  id="Quantity"
                  name="Quantity"
                  v-model="drugObj.quantity"
                  @keypress="preventDecimalPoint"
                /> -->
                <v-select :options="quantityList" v-model="drugObj.quantity" id="doseUnit" name="Dose Unit" class=" sa-v-slct-lg"><span slot="no-options">No data</span></v-select>
                <span v-if="errors[0] || qcQuantityError" class="sa-val-err">{{ errors[0] || qcQuantityError }}</span>
                <span v-else-if="liveLimitCheck && liveLimitCheck.maxBoxes != null" class="sa-val-err sa-light-green-text">Max allowed: {{ liveLimitCheck.maxBoxes }} {{ liveLimitCheck.maxBoxes === 1 ? 'box' : 'boxes' }}</span>
              </div>
            </ValidationProvider>
            <!-- <ValidationProvider
              class="sa-col-xs6 sa-col-sm6 sa-col-md3 sa-col-lg3"
              tag="div"
              rules="required"
              name="Dose Unit"
              v-slot="{ errors }"
            > -->
              <!-- <div class="sa-col-xs6 sa-col-sm6 sa-col-md3 sa-col-lg3">
                <input
                  type="text"
                  class="sa-form-control sa-form-control-lg sa-mt22"
                  id="dose"
                  name="Dose"
                  :disabled="!dflag"
                  v-model="drugObj.package_type"
                />
              </div> -->
            <!-- </ValidationProvider> -->
            <ValidationProvider
              class="sa-col-xs12 sa-col-sm6 sa-col-md5 sa-col-lg4"
              tag="div"
              rules="required"
              name="Frequency"
              v-slot="{ errors }"
            >
              <div class="sa-form-group">
                <label>Frequency<span class="sa-red-text">*</span></label>
                <v-select
                  :options="frequency"
                  v-model="drugObj.freq_nm"
                  id="frequency"
                  name="Frequency"
                  class="sa-v-slct-lg"
                  ><span slot="no-options">No data</span></v-select
                >
                <span class="sa-val-err">{{ errors[0] }}</span>
                <span v-if="day_cnt" class="sa-val-err sa-light-green-text">{{day_cnt}}</span>
              </div>
            </ValidationProvider>
            <ValidationProvider
              class="sa-col-xs6 sa-col-sm6 sa-col-md5 sa-col-lg2"
              tag="div"
              rules="required"
              name="Duration"
              v-slot="{ errors }"
            >
              <div class="sa-form-group">
                <label>Duration<span class="sa-red-text">*</span></label>
                <input
                  type="text"
                  class="sa-form-control sa-form-control-lg"
                  id="duration"
                  v-model="drugObj.dur"
                  name="Duration"
                />
                <span class="sa-val-err">{{ errors[0] || qcDurationError }}</span>
              </div>
            </ValidationProvider>
            <ValidationProvider
              class="sa-col-xs6 sa-col-sm6 sa-col-md5 sa-col-lg2"
              tag="div"
              rules="required"
              name="Duration Unit"
              v-slot="{ errors }"
            >
              <div class="sa-form-group">
                <label>Duration Unit<span class="sa-red-text">*</span></label>
                <v-select
                  :options="duration"
                  v-model="drugObj.dur_unit"
                  id="durationUnit"
                  name="Duration Unit"
                  class="sa-v-slct-lg"
                  ><span slot="no-options">No data</span></v-select
                >
                <span class="sa-val-err">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
            <div class="sa-col-xs12 sa-col-sm6 sa-col-md5 sa-col-lg4">
              <div class="sa-form-group">
                <label>PRN</label>
                <input
                  type="text"
                  class="sa-form-control sa-form-control-lg sa-disabled"
                  disabled
                  v-model="drugObj.prn"
                />
                <span class="sa-checkinput">
                  <input
                    @click="changePRN"
                    type="checkbox"
                    id="checkbox"
                    v-model="checkbox"
                    name="checkbox" />
                  <label for="checkbox"></label
                ></span>
              </div>
            </div>
            <!-- <ValidationProvider
              class="sa-col-xs12 sa-col-sm6 sa-col-md5 sa-col-lg6"
              tag="div"
              rules="required"
              name="Indications"
              v-slot="{ errors }"
            >
              <div class="sa-form-group">
                <label>Indications<span class="sa-red-text">*</span></label>
                <input
                  type="textarea"
                  class="sa-form-control sa-form-control-lg"
                  id="indications"
                  name="Indications"
                  v-model="drugObj.indications"
                  rows="4"
                  autocomplete="off"
                />
                <span class="sa-val-err">{{ errors[0] }}</span>
              </div>
            </ValidationProvider> -->
            <div
              class="sa-col-xs12 sa-col-sm6 sa-col-md5 sa-col-lg6"
              name="Instructions"
            >
              <div class="sa-form-group">
                <label>Instructions</label>
                <input
                  type="textarea"
                  class="sa-form-control sa-form-control-lg"
                  v-model="drugObj.inst"
                  name="Instructions"
                  id="instructions"
                  rows="4"
                />
              </div>
            </div>
            <!-- <ValidationProvider
              class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg6"
              tag="div"
              v-if="generic && generic.sales_channel == 'bupa'"
              rules="required"
              name="Bupa Diagnosis"
              v-slot="{ errors }"
            >
              <div  class="sa-form-group">
                <label>Diagnosis<span class="sa-red-text">*</span></label>
                <input
                  type="text"
                  class="sa-form-control sa-form-control-lg"
                  id="bupa_diagnosis"
                  name="Bupa Diagnosis" @click="BupaDiagnoFlag = true"
                  v-model="drugObj.icd10_code.en"
                  readonly
                />
                <span class="sa-val-err">{{ errors[0] }}</span>
              </div>
            </ValidationProvider> -->
            </div>
            <ValidationProvider
              class="sa-col-xs12 sa-col-sm6 sa-col-md5 sa-col-lg4"
              tag="div"
              v-if="sales_channel=='bupa_refill' && editflag"
              rules="required"
              name="Reason"
              v-slot="{ errors }"
            >
              <div v-if="sales_channel=='bupa_refill' && editflag" class="sa-form-group">
                <label>Reason</label>
                <input
                  type="textarea"
                  class="sa-form-control sa-form-control-lg"
                  v-model="drugObj.reason"
                  name="reason"
                  id="reason"
                  rows="4"
                />
              <span class="sa-val-err">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
            <div
              v-if="qcCard"
              ref="limitCheckCard"
              class="sa-dose-limit-inline"
            >
              <div class="sa-dose-limit-card">
                <div
                  v-if="qcCard.dailyDoseCheck"
                  class="sa-dose-check-block"
                >
                  <div class="sa-dose-check-title">{{ qcCard.dailyDoseCheck.title }}</div>
                  <div class="sa-dose-check-desc">{{ qcCard.dailyDoseCheck.desc }}</div>
                  <div class="sa-dose-check-max">{{ qcCard.dailyDoseCheck.max }}</div>
                  <div
                    v-if="qcCard.dailyDoseCheck.displayText"
                    class="sa-dose-check-banner"
                    :class="qcCard.dailyDoseCheck.withinlimit ? 'is-ok' : 'is-err'"
                  >
                    <span class="sa-dose-check-icon" aria-hidden="true">
                      <svg v-if="qcCard.dailyDoseCheck.withinlimit" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <circle cx="10" cy="10" r="8.5" stroke="currentColor" stroke-width="1.5"/>
                        <path d="M6 10.2l2.6 2.6L14.2 7.2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <circle cx="10" cy="10" r="8.5" stroke="currentColor" stroke-width="1.5"/>
                        <path d="M7 7l6 6M13 7l-6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                      </svg>
                    </span>
                    <span>{{ qcCard.dailyDoseCheck.displayText }}</span>
                  </div>
                </div>
                <div
                  v-if="qcCard.dailyDoseCheck && (qcCard.quantityCheck || qcCard.durationCheck)"
                  class="sa-dose-check-divider"
                ></div>
                <div
                  v-if="qcCard.quantityCheck"
                  class="sa-dose-check-block"
                >
                  <div class="sa-dose-check-title">{{ qcCard.quantityCheck.title }}</div>
                  <div class="sa-dose-check-desc">{{ qcCard.quantityCheck.desc }}</div>
                  <div class="sa-dose-check-max">{{ qcCard.quantityCheck.max }}</div>
                  <div
                    v-if="qcCard.maxBoxes != null"
                    class="sa-dose-check-allowed"
                  >
                    <span>Maximum allowed</span>
                    <strong>{{ qcCard.maxBoxes }} Boxes</strong>
                  </div>
                  <div
                    v-if="qcCard.quantityCheck.displayText"
                    class="sa-dose-check-banner"
                    :class="qcCard.quantityCheck.withinlimit ? 'is-ok' : 'is-err'"
                  >
                    <span class="sa-dose-check-icon" aria-hidden="true">
                      <svg v-if="qcCard.quantityCheck.withinlimit" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <circle cx="10" cy="10" r="8.5" stroke="currentColor" stroke-width="1.5"/>
                        <path d="M6 10.2l2.6 2.6L14.2 7.2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <circle cx="10" cy="10" r="8.5" stroke="currentColor" stroke-width="1.5"/>
                        <path d="M7 7l6 6M13 7l-6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                      </svg>
                    </span>
                    <span>{{ qcCard.quantityCheck.displayText }}</span>
                  </div>
                </div>
                <div
                  v-if="qcCard.quantityCheck && qcCard.durationCheck"
                  class="sa-dose-check-divider"
                ></div>
                <div
                  v-if="qcCard.durationCheck"
                  class="sa-dose-check-block"
                >
                  <div class="sa-dose-check-title">{{ qcCard.durationCheck.title }}</div>
                  <div class="sa-dose-check-desc">{{ qcCard.durationCheck.desc }}</div>
                  <div class="sa-dose-check-max">{{ qcCard.durationCheck.max }}</div>
                  <div
                    v-if="qcCard.durationCheck.displayText"
                    class="sa-dose-check-banner"
                    :class="qcCard.durationCheck.withinlimit ? 'is-ok' : 'is-err'"
                  >
                    <span class="sa-dose-check-icon" aria-hidden="true">
                      <svg v-if="qcCard.durationCheck.withinlimit" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <circle cx="10" cy="10" r="8.5" stroke="currentColor" stroke-width="1.5"/>
                        <path d="M6 10.2l2.6 2.6L14.2 7.2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <circle cx="10" cy="10" r="8.5" stroke="currentColor" stroke-width="1.5"/>
                        <path d="M7 7l6 6M13 7l-6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                      </svg>
                    </span>
                    <span>{{ qcCard.durationCheck.displayText }}</span>
                  </div>
                </div>
              </div>
            </div>
            </div>

            <div v-if="medicationFlag" class="sa-ftr-btn">
              <button
                class="sa-btn sa-btn-large sa-btn-default"
                @click="backMedication"
              >
              Correct
              </button>
              <button
                class="sa-btn sa-btn-large sa-btn-primary sa-ml20"
                :disabled="loader"
                @click="handleSubmit(SaveDrug)"
              >
                Proceed
              </button>
            </div>

            <div v-else class="sa-ftr-btn">
              <button
                class="sa-btn sa-btn-large sa-btn-default"
                @click="backAction"
              >
                Discard
              </button>
              <button
                class="sa-btn sa-btn-large sa-btn-primary sa-ml20"
                :disabled="loader || isLimitSaveLocked"
                @click="handleSubmit(SaveDrug)"
              >
                Save Drug
              </button>
            </div>
            <div class="sa-dialog sa-assegements" v-if="ScientificFlag">
              <div class="sa-dialog-body sa-device">
                <i class="icon-arrow-left sa-f-size22" @click="ScientificFlag = false"></i>
                <!-- <i class="icon-close sa-close sa-btn sa-close-line" @click="ScientificFlag = false"></i> -->
                <scientific-names :drugs="drugObj" />
              </div>
            </div>
            <div class="sa-dialog sa-assegements" v-if="DrugNameFlag">
              <div class="sa-dialog-body sa-device">
                <i class="icon-arrow-left sa-f-size22" @click="DrugNameFlag = false"></i>
                <!-- <i class="icon-close sa-close sa-btn sa-close-line" @click="DrugNameFlag = false"></i> -->
                <drug-names :generic="generic" :drugs="drugObj" />
              </div>
            </div>
            <div class="sa-dialog sa-assegements" v-if="BupaDiagnoFlag">
              <div class="sa-dialog-body sa-device">
                <i class="icon-close sa-close sa-btn sa-close-line" @click="BupaDiagnoFlag = false"></i>
                <bupa-diagnosis />
              </div>
            </div>
          </ValidationObserver>
      </template>
    </div>
    <add-medicine-view
      ref="addMedicine"
      :generic="generic"
      @removeDrug="removeDrug($event)"
       @removeBupaDrug="removeBupaDrug($event)"
      @editDrug="editDrug($event)"
      @addDrug="addDrug($event)"
      :drugList="drugList"
      :listData="listData"
      :load="loading"
      v-if="viewMedFlag"
    />
  </div>
</template>
<script>
import AddMedicineViewVue from "../../diagnosis/prescription/AddMedicineView.vue";
import ScientificNamesVue from "../../diagnosis/prescription/ScientificNames.vue";
import DrugNamesVue from "../../diagnosis/prescription/DrugNames.vue";
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import { pro_url, oh_url } from "../../../../../config/endpoints";
import async from "async";
import _ from "lodash";
import BupaDiagnosisVue from './BupaDiagnosis.vue';
import Loader from "../../../common/loader.vue";
import { computePrescriptionChecks } from "../../../../util/prescriptionQc";

extend("required", {
  ...required,
  message: "Please provide {_field_}",
});
extend("maxQuantity", {
  validate(value) {
    return parseInt(value) <= 12;
  },
  message: "The {_field_} must be 12 or less",
});
export default {
  components: {
    "add-medicine-view": AddMedicineViewVue,
    "scientific-names": ScientificNamesVue,
    "drug-names": DrugNamesVue,
    "bupa-diagnosis": BupaDiagnosisVue,
    Loader
  },
  data() {
    return {
      loadFlag:false,
      oldIndication:null,
      reason:null,
      isActive: false,
      ScientificFlag: false,
      DrugNameFlag: false,
      BupaDiagnoFlag: false,
      assesment: [],
      daycounts:{},
      dflag: false,
      routes: [],
      scientifics: [],
      drugs: [],
      frequency: [],
      frequencies:{},
      duration: [],
      durData: {},
      doseUnits: [],
      quantityList: Array.from({ length: 10 }, (_, i) => i + 1),
      milk: [],
      device: [],
      supplies: [],
      checkbox: false,
      generic: null,
      listData:null,
      sales_channel:null,
      details: null,
      apnt_id: null,
      day_cnt:null,
      loading: true,
      drugList: null,
      drgid: null,
      dept: "",
      patDetails: null,
      loader: false,
      drugFlag: false,
      viewMedFlag: false,
      editflag : false,
      clinicInfoReq: "",
      medicationFlag:false,
      limitCheckData: null,
      limitCheckSnapshot: null,
      governance: null,
      qcForm: null,
      drugObj: {
        ins_med:false,
        apnt_id: null,
        scientific_name: null,
        pid: null,
        drug_nm: null,
        dose: null,
        route: null,
        quantity: null,
        dose_unit: null,
        freq_nm: null,
        freq_id: null,
        dur: null,
        package_type:null,
        dur_unit: null,
        prn: "NO",
        pharm:null,
        indications: null,
        icd10_code: {
          en: null,
          icd10_code: null
        },
        inst: null,
        milk:"",
        milk_inst:"",
        device:"",
        device_inst:"",
        supplies:"",
        supplies_inst:"",
        prd_any_way:false
      },
    };
  },
  watch: {
    qcFormInput: {
      immediate: true,
      handler(val) {
        if (this.updateQcForm) this.updateQcForm(val);
        else this.qcForm = val;
      },
    },
    "drugObj.quantity":{
      immediate: true,
      handler(val) {
        if (val < 1) {
          this.drugObj.quantity = null
          return
        }
        this.clearQuantityOverMax()
      },
    },
    liveLimitCheck() {
      this.clearQuantityOverMax()
    },
    "drugObj.scientific_name": {
      immediate: true,
      handler(val) {
        if (val) {
          if(this.drugObj.scientific_name && this.drugObj.drug_nm){
            this.getDrugData();
          }
        }
      },
    },
    "drugObj.indications": {
      immediate: true,
      handler(val) {
        if (val && val != this.oldIndication && val?.length > 6) {
          this.medicationFlag = false
          this.drugObj.prd_any_way = false
        }
      }
    },
    "drugObj.freq_nm":{
      immediate: true,
      handler(val){
        if(val){
           for(let i in this.frequencies){
                if(this.frequencies[i] == val){
                  this.drugObj.freq_id = i
                }
              }
          for(let key in this.daycounts){
            if(val == key){
              // for(let i in this.frequencies){
              //   if(this.frequencies[i] == key){
              //     this.drugObj.freq_id = i
              //   }
              // }
              this.day_cnt = this.daycounts[key]
            }
          }
          // let ref = this.frequencies.find(f => val == _.values(f))
          // console.log(ref);
        }
      }
    },
    "drugObj.drug_nm": {
      immediate: true,
      handler(val) {
        if (val) {
          this.getScientificData()
          if(this.drugObj.scientific_name && this.drugObj.drug_nm){
            this.getDrugData();
          }
        }
      },
    },
  },
  computed: {
    qcFormInput() {
      const d = this.drugObj || {};
      const durUnitId = this.durData && d.dur_unit
        ? Object.keys(this.durData).find((key) => this.durData[key] === String(d.dur_unit))
        : null;
      const icdCode = typeof d.indications === "string" ? d.indications.split(" ")[0] : null;
      return {
        dose: d.dose,
        dose_unit: d.dose_unit,
        freq_id: d.freq_nm ? d.freq_id : null,
        dur: d.dur,
        dur_unit: d.dur_unit,
        dur_unit_id: durUnitId,
        quantity: d.quantity,
        icd_code: icdCode,
      };
    },
    liveLimitCheck() {
      return computePrescriptionChecks(this.qcForm, this.governance);
    },
    qcCard() {
      return this.liveLimitCheck || this.limitCheckData;
    },
    qcDailyError() {
      const c = this.liveLimitCheck && this.liveLimitCheck.dailyDoseCheck;
      return c && !c.withinlimit ? c.displayText : null;
    },
    qcQuantityError() {
      const c = this.liveLimitCheck && this.liveLimitCheck.quantityCheck;
      return c && !c.withinlimit ? c.displayText : null;
    },
    qcDurationError() {
      const c = this.liveLimitCheck && this.liveLimitCheck.durationCheck;
      return c && !c.withinlimit ? c.displayText : null;
    },
    isLimitSaveLocked() {
      if (this.liveLimitCheck) return this.liveLimitCheck.failed;
      if (!this.limitCheckData || !this.limitCheckSnapshot) return false;
      const snapshot = this.limitCheckSnapshot;
      return (
        this.drugObj.dose == snapshot.dose &&
        this.drugObj.quantity == snapshot.quantity &&
        this.drugObj.dur == snapshot.dur &&
        this.drugObj.dur_unit == snapshot.dur_unit &&
        this.drugObj.dose_unit == snapshot.dose_unit &&
        this.drugObj.freq_nm == snapshot.freq_nm
      );
    },
  },
  methods: {
    getScientificData() {
      let _self = this
     let data = {
          limit: 30,
	        page: 1,
          drug_nm:  this.drugObj.drug_nm
          }  
      _self.$store
        .dispatch("httpPost", {
          uri: `${oh_url}/general/drugsList`,
          body: data,
        })
        .then((response) => {
          if ((response.status === 1000)) {
            if (response && response.status === 1000 && response.data && response.data.data && response.data.data.scientifi_names && response.data.data.scientifi_names.length) {
               _self.drugObj.scientific_name = response.data.data.scientifi_names[0]
               this.getDrugData();
              } 
          }
        })
        .catch((e) => {
          console.log(e)
        });
    },
    preventDecimalPoint(event) {
      // Get the key code of the pressed key
      const keyCode = event.keyCode || event.which;
      // Allow control keys such as backspace, delete, arrow keys, etc.
      const controlKeys = [8, 9, 13, 27, 37, 38, 39, 40]; // Add other control key codes as needed
      if (controlKeys.includes(keyCode)) {
        return;
      }
      // Get the character from the key code
      const char = String.fromCharCode(keyCode);
      // Prevent decimal points, commas, and any other special characters
      if (!/[0-9]/.test(char)) {
        event.preventDefault();
      }
    },
    removeScintific(){
        this.governance = null;
        this.drugObj.route = null;
        this.drugObj.pharm = null;
        this.drugObj.scientific_name = null
    },
    removeDrugName(){
      this.governance = null;
      this.drugObj.ins_med = false
        this.drugObj.route = null;
        this.drugObj.pharm = null;
        this.drugObj.drug_nm = null

    },
    removeMilk(){
      this.drugObj.milk = null;
      this.drugObj.milk_inst = null;
    },
    removeDevice(){
      this.drugObj.device = null;
      this.drugObj.device_inst = null;
    },
    removeSupplies(){
      this.drugObj.supplies = null;
      this.drugObj.supplies_inst = null;
    },
    changePRN: function () {
      this.drugObj.prn = this.checkbox ? "NO" : "PRN";
      // this.$set(this.drugObj.prn, prn)
    },
    backMedication: function (){
      // webview back button
        if (typeof window != undefined && window.ReactNativeWebView) {
          let data = {
            action: "end",
          };
          window.ReactNativeWebView.postMessage(JSON.stringify(data));
        }
        this.$router.push(
          "/appointments/doctor-details/add-diagnosis/" +
            this.$route.params.appid
        );
    },
    clearQuantityOverMax() {
      const maxBoxes = this.liveLimitCheck && this.liveLimitCheck.maxBoxes
      const qty = Number(this.drugObj.quantity)
      if (maxBoxes == null || maxBoxes < 1 || Number.isNaN(qty)) return
      if (qty > maxBoxes) this.drugObj.quantity = null
    },
    closeLimitCheck() {
      this.limitCheckData = null;
      this.limitCheckSnapshot = null;
    },
    isLimitCheckError(response) {
      const desc = response && response.desc;
      return (
        response &&
        response.status === 1001 &&
        desc === "QC_FAILED"
      );
    },
    handleSaveFailure(response, indications) {
      this.drugObj.indications = indications;
      if (this.isLimitCheckError(response) && response.data) {
        this.limitCheckData = response.data;
        this.limitCheckSnapshot = {
          dose: this.drugObj.dose,
          quantity: this.drugObj.quantity,
          dur: this.drugObj.dur,
          dur_unit: this.drugObj.dur_unit,
          dose_unit: this.drugObj.dose_unit,
          freq_nm: this.drugObj.freq_nm,
        };
        this.$nextTick(() => {
          const card = this.$refs.limitCheckCard;
          if (card && card.scrollIntoView) {
            card.scrollIntoView({ behavior: "smooth", block: "nearest" });
          }
        });
        return;
      }
      if (response && response.desc && response.desc == "ICD_MED") {
        this.oldIndication = this.drugObj.indications;
        this.medicationFlag = true;
        this.drugObj.prd_any_way = true;
      }
      this.$store.dispatch("SET_ALERTMESSAGE", {
        msg:
          response && response.message
            ? response.message
            : "Something went wrong. Please try again or contact operations team",
        class: "sa-a-danger",
      });
    },
    backAction: function () {
      if (this.drugList && this.drugList.length) {
        this.viewMedFlag = true;
        this.drgid = null;
      } else {
        // webview back button
        if (typeof window != undefined && window.ReactNativeWebView) {
          let data = {
            action: "end",
          };
          window.ReactNativeWebView.postMessage(JSON.stringify(data));
        }
        this.$router.push(
          "/appointments/doctor-details/add-diagnosis/" +
            this.$route.params.appid
        );
      }
    },
     removeBupaDrug(drgid) {
      this.viewMedFlag = false;
      this.loading = true;
      let _self = this;
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/prescription/remove`,
          body: {
            drgid: drgid,
            reason:this.reason
          },
        })
        .then((response) => {
          _self.loading = false;
          if (response && response.status === 1000) {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: "Deleted drug successfully",
              class: "sa-a-success",
            });
                _self.day_cnt = null,
            _self.fetchList(function () {});
          } else {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: "Something went wrong. Please try again or contact operations team",
              class: "sa-a-danger",
            });
          }
        });
    },
    removeDrug(drgid) {
      this.viewMedFlag = false;
      this.loading = true;
      let _self = this;
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/prescription/delete`,
          body: {
            drgid: drgid,
          },
        })
        .then((response) => {
          _self.loading = false;
          if (response && response.status === 1000) {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: "Deleted drug successfully",
              class: "sa-a-success",
            });
            _self.drugObj ={
                  apnt_id: null,
                  scientific_name: null,
                  pid: null,
                  drug_nm: null,
                  dose: null,
                  route: null,
                  dose_unit: null,
                  freq_nm: null,
                  dur: null,
                  dur_unit: null,
                  prn: "NO",
                  pharm:null,
                  indications: null,
                  icd10_code: {
                    en: null,
                    icd10_code: null
                  },
                  inst: null,
                },
                _self.day_cnt = null,
            _self.fetchList(function () {});
          } else {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: "Something went wrong. Please try again or contact operations team",
              class: "sa-a-danger",
            });
          }
        });
    },
    
    editDrug(drgid) {
      // webview back button
      if (typeof window != undefined && window.ReactNativeWebView) {
        let data = {
          action: "back",
          page: "add medicine",
          appLoad: "false"
        };
        window.ReactNativeWebView.postMessage(JSON.stringify(data));
      }
      this.editflag = true;
      this.viewMedFlag = false;
      this.loading = true;
      this.drgid = drgid;
      let _self = this;
      _self.$store
        .dispatch("httpGet", {
          uri: `${pro_url}/prescription/Details/${drgid}`,
        })
        .then((response) => {
          _self.loading = false;
          if (response && response.status === 1000) {
            _self.drugObj = response.data;
          }
        });
    },
    addDrug(){
      let _self = this
      _self.limitCheckData = null;
      _self.limitCheckSnapshot = null;
      _self.governance = null;
      if (typeof window != undefined && window.ReactNativeWebView) {
        let data = {
          action: "back",
          page: "add medicine",
        };
        window.ReactNativeWebView.postMessage(JSON.stringify(data));
      }
      _self.drugObj ={
                  apnt_id: null,
                  scientific_name: null,
                  pid: null,
                  drug_nm: null,
                  dose: null,
                  route: null,
                  dose_unit: null,
                  freq_nm: null,
                  dur: null,
                  dur_unit: null,
                  prn: "NO",
                  pharm:null,
                  indications: null,
                  icd10_code: {
                    en: null,
                    icd10_code: null
                  },
                  inst: null,
                    prd_any_way:false
                }
    },
    fetchList(cb) {
      this.loading = true;
      let _self = this;
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/prescription/list`,
          body: {
            apnt_id: _self.apnt_id,
          },
        })
        .then((response) => {
          if (response && response.status === 1000) {
            if (
              response.data &&
              response.data &&
              response.data.prescflags.presc_exists
            ) {
              // webview back button
              if (typeof window != undefined && window.ReactNativeWebView) {
                let data = {
                  action: "back",
                  page: "prescription list",
                };
                window.ReactNativeWebView.postMessage(JSON.stringify(data));
              }
              _self.viewMedFlag = true;
              _self.drugList = response.data.prescription_list;
              _self.generic = response.data.general;
              _self.listData = response.data;
              _self.sales_channel = response.data.general.sales_channel
            } else {
              // webview back button
              // if (typeof window != undefined && window.ReactNativeWebView) {
              //   let data = {
              //     action: "back",
              //     page: "add medicine",
              //   };
              //   window.ReactNativeWebView.postMessage(JSON.stringify(data));
              // }
              // _self.generic = response.data.general;
              // _self.drugList = null;
              if(this.listData?.prescflags?.new_presc_flow){
                if (response?.data?.prescflags?.presc_exists) {
                  this.viewMedFlag = true;
                  this.drgid = null;
                } else {
                    // webview back button
                    if (typeof window != undefined && window.ReactNativeWebView) {
                        let data = {
                          action: "end",
                        };
                      window.ReactNativeWebView.postMessage(JSON.stringify(data));
                    }
                      this.$router.push(
                        "/appointments/doctor-details/add-diagnosis/" +
                        this.$route.params.appid
                      );
                  }
              }else{
                // webview back button
              if (typeof window != undefined && window.ReactNativeWebView) {
                let data = {
                  action: "back",
                  page: "add medicine",
                };
                  window.ReactNativeWebView.postMessage(JSON.stringify(data));
              }
                _self.generic = response.data.general;
                _self.drugList = null;
              }
              
            }
          }
          _self.loadFlag = true
          _self.loading = false;
          return cb();
        });
    },
    fetchPatDetails(cb) {
      let _self = this;
      if (_self.$route.query.token) {
        if(_self.$route.query.refreshToken){
          _self.$localStorage.set('refresh_token', _self.$route.query.refreshToken)
        }
        _self.$store
          .dispatch("httpGet", {
            uri: `${pro_url}/apt/${_self.$route.params.appid}`,
            query: {},
          })
          .then((response) => {
            if (response && response.status === 1000) {
              _self.details = response.data;
              _self.patDetails = {
                apnt_id: _self.details.apnt_id,
                pid: _self.details.pid,
                sanar_uid: _self.details.sanar_uid,
              };
              _self.$localStorage.set(
                "patDetails",
                JSON.stringify(_self.patDetails)
              );
              return cb();
            } else {
              return cb();
            }
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        return cb();
      }
    },
    getPrescriptionData() {
      let _self = this;
      _self.$store
        .dispatch("httpGet", {
          uri: `${pro_url}/getPrescriptionMasterData`,
        })
        .then((response) => {
          if ((response.status === 1000)) {
            _self.doseUnits = _.values(response.data.doseunits);
            _self.duration = _.values(response.data.durations);
            _self.durData = response.data.durations;
            _self.frequency = _.values(response.data.frequencies);
            _self.freqData = response.data.frequencies;
            _self.frequencies = response.data.frequencies
            _self.routes = _.values(response.data.routes);
            _self.daycounts = response.data.daycounts;
            _self.milk = _.values(response.data.milk)
            _self.supplies = _.values(response.data.supplies)
            _self.device = _.values(response.data.devices)
            //_self.scientifics = response.data.scientifics;
          }
        })
        .catch((e) => {
          console.log(e)
        });
    },
    scientific_check() {
      // if(this.drugObj.drug_nm){
      //   let data = {
      //     drug_nm : this.drugObj.drug_nm
      //   }
      //   this.getDrugData(data)
      // }
        this.ScientificFlag = true
    },
    drugs_check() {
      // if(this.drugObj.scientific_name){
      //   let data = {
      //     scientific_name : this.drugObj.scientific_name
      //   }
      //   this.getDrugData(data)
      // }
        this.DrugNameFlag = true
    },
    getDrugData() {
      let _self = this
      let data = {
        scientific_name : this.drugObj.scientific_name,
        drug_nm : this.drugObj.drug_nm,
        apnt_id : this.apnt_id
      }
      _self.governance = null
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/prescription/data`,
          body: data,
        })
        .then((response) => {
          if ((response && response.status == 1000)) {
              _self.governance = response.governance || null
              if (_self.drugObj && _self.drugObj.drug_nm && _self.drugObj.scientific_name) {
                _self.drugObj.route = response.data[0].ROUTE;
                _self.drugObj.pharm = response.data[0].PHARMACEUTICAL_FORM;
                _self.drugObj.package_type = response.data[0].PACKAGE_TYPES;
                if(response && response.data && response.data[0] && response.data[0].MAX_QTY){
                   _self.drugObj.quantity = null
                  _self.quantityList = Array.from({ length: response.data[0].MAX_QTY }, (_, i) => i + 1)
                }else{
                   _self.drugObj.quantity = null
                  _self.quantityList = Array.from({ length: 10 }, (_, i) => i + 1)
                }
  

              }
              //  else if(_self.drugObj && _self.drugObj.drug_nm ){
              //     this.scientifics.push(e.SCIENTIFIC_NAME);
              // } else if(_self.drugObj && _self.drugObj.scientific_name ){
              //     this.drugs.push(e.DRUG_NAME);
              // }
          }
        })
        .catch((e) => {
          console.log(e)
        });
    },
    getprescData(){
      let _self = this
      let data = {
        "limit": 15,
        "page": 1,
      }
        _self.$store
        .dispatch("httpPost", {
          uri: `${oh_url}/general/drugsList`,
          body: data,
        })
        .then((response) => {
          if ((response.status === 1000)) {
            this.scientifics = response.data.data.scientifi_names
            this.drugs = response.data.data.drug_names
            // _.map(response.data, (e) => {
            //   this.scientifics.push(e.scientifi_names)
            //   this.drugs.push(e.drug_names);
            //   return e;
            // });
          }
        })
        .catch((e) => {
          console.log(e)
        });
    },
    SaveDrug() {
      let _self = this;
      // console.log(_self.drugObj);
      _self.limitCheckData = null;
      _self.limitCheckSnapshot = null;
      _self.drugObj.apnt_id = _self.apnt_id;
      _self.drugObj.prd_any_way =  _self.drugObj.prd_any_way ?   _self.drugObj.prd_any_way : false
      _self.drugObj.pid = _self.patDetails.pid;
      _self.loading = true;
      _self.drugObj.dur_unit_id = Object.keys(_self.durData).find(key => _self.durData[key] === String( _self.drugObj.dur_unit))
      let ind = _self.drugObj.indications
      _self.drugObj.indications = _self.drugObj.indications.split(" ")[0]
      if(_self.drugObj && _self.drugObj.icd10_code && _self.drugObj.icd10_code.icd10_code){
        _self.drugObj.icd10_code = _self.drugObj.icd10_code.icd10_code
      }else{
        _self.drugObj.icd10_code = undefined
      }
      if (_self.drgid) {
        _self.drugObj.drgid = _self.drgid;
        if(this.sales_channel == 'bupa_refill'){
        _self.drugObj.ACTION = "Editted"
        }
        // delete _self.drugObj.apnt_id;
        delete _self.drugObj.pid;
        _self.drugObj.milk = _self.drugObj.milk ? _self.drugObj.milk  : ""

        _self.$store
          .dispatch("httpPost", {
            uri: `${pro_url}/prescription/edit`,
            body: _self.drugObj,
          })
          .then((response) => {
            _self.loading = false;
            if (response && response.status === 1000) {
              _self.$store.dispatch("SET_ALERTMESSAGE", {
                msg: "Updated drug successfully. Redirecting to Drug list",
                class: "sa-a-success",
              });
               _self.medicationFlag = false
               this.editflag = false;
              _self.drgid = null;
              _self.checkbox = false;
              _self.drugObj= {
                  apnt_id: null,
                  scientific_name: null,
                  pid: null,
                  drug_nm: null,
                  dose: null,
                  route: null,
                  dose_unit: null,
                  freq_nm: null,
                  quantity:null,
                  dur: null,
                  dur_unit: null,
                  prn: "NO",
                  pharm:null,
                  indications: null,
                  icd10_code: {
                    en: null,
                    icd10_code: null
                  },
                  inst: null,
                  },
              _self.fetchList(function () {});
            } else {
              _self.handleSaveFailure(response, ind);
            }
          });
      } else {
        if(this.sales_channel == 'bupa_refill'){
          _self.drugObj.ACTION = "New"
        }
        _self.drugObj.milk = _self.drugObj.milk ? _self.drugObj.milk  : ""
        _self.$store
          .dispatch("httpPost", {
            uri: `${pro_url}/prescription/add`,
            body: _self.drugObj,
          })
          .then((response) => {
            _self.loading = false;
            if (response && response.status === 1000) {
               _self.medicationFlag = false
              _self.$store.dispatch("SET_ALERTMESSAGE", {
                msg: "Added drug successfully. Redirecting to Drug list",
                class: "sa-a-success",
              });
              _self.fetchList(function () {});
            } else {
              _self.handleSaveFailure(response, ind);
            }
          });
      }
    },
    getAssementData(){
      let _self = this
      let data = {
        apnt_id : this.$route.params.appid
      }

        _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/prescription/assessment`,
          body: data,
        })
        .then((response) => {
          // console.log(response,'res');
          if (response) {
           _self.assesment = _.values(response.data.Assesment);
           if(!_self.assesment.length){
              _self.$store.dispatch("SET_ALERTMESSAGE", {
                msg: "Please select one assesment",
                class: "sa-a-danger",
              });
           }
            // _.map(response.data, (e) => {
            //   this.scientifics.push(e.scientifi_names)
            //   this.drugs.push(e.drug_names);
            //   return e;
            // });
          }
        })
        .catch((e) => {
          console.log(e)
        });
    },
  },
  created() {
    this.updateQcForm = _.debounce((val) => {
      this.qcForm = val;
    }, 300);
  },
  beforeDestroy() {
    if (this.updateQcForm) this.updateQcForm.cancel();
  },
  mounted() {
    let _self = this;
     _self.day_cnt = null
    //  console.log(_self.day_cnt,'ssss');
    _self.getPrescriptionData();
    _self.getprescData();
    _self.getAssementData();
    var field = document.createElement("input");
    field.setAttribute("type", "text");
    document.body.appendChild(field);
    // Simulate loading delay or wait for async data
    setTimeout(() => {
      this.loading = false;
    }, 2000); 

    //  console.log(_self.assesment);
    setTimeout(function () {
      field.focus();
      setTimeout(function () {
        field.setAttribute("style", "display:none;border:transparent;border-color:#FFF");
      }, 0);
    }, 0);
    if (typeof window != "undefined") {
      window.addEventListener("message", function (message) {
        if (message && message.data) {
          let res = JSON.parse(message.data);
          if (res && res.action == "back") {
            if (res.page == "prescription list") {
              // webview back button
              if (window.ReactNativeWebView) {
                let data = {
                  action: "end",
                };
                window.ReactNativeWebView.postMessage(JSON.stringify(data));
              }
            } else if (res.page == "add medicine") {
              _self.backAction();
            } else if (res.page == "issue prescription") {
              if (!_self.$refs["addMedicine"].saveDrugFlag) {
                _self.$refs["addMedicine"].saveDrugFlag = true;
                _self.$refs["addMedicine"].saveDrugViewFlag = true;
              } else {
                _self.$refs["addMedicine"].saveDrugFlag = false;
                _self.$refs["addMedicine"].saveDrugViewFlag = false;
              }
            } else if (res.page == "complete") {
              if (window.ReactNativeWebView) {
                let data = {
                  action: "complete",
                };
                window.ReactNativeWebView.postMessage(JSON.stringify(data));
              }
            }
          }
        }
      });
    }
    this.patDetails = JSON.parse(this.$localStorage.get("patDetails"));
    if (this.patDetails) {
      this.apnt_id = this.patDetails.apnt_id;
    }
    if (this.$route.params.appid) {
      this.apnt_id = this.$route.params.appid;
    }
    this.loading = true;
    // this.fetchList()
    async.parallel(
      [_self.fetchList.bind(), _self.fetchPatDetails.bind()],
      function () {
        _self.loading = false;
      }
    );
  },
};
</script>
<style scoped>
.sa-dose-limit-inline {
  width: 100%;
  margin: 8px 0 16px;
}
.sa-dose-limit-card {
  background: #f4f8fc;
  border: 1px solid #e4ebf2;
  border-radius: 12px;
  padding: 16px;
}
.sa-dose-check-title {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #9aa0a6;
  margin-bottom: 8px;
}
.sa-dose-check-desc {
  font-size: 14px;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1.4;
  margin-bottom: 4px;
}
.sa-dose-check-max {
  font-size: 13px;
  color: #6b7280;
  line-height: 1.4;
  margin-bottom: 10px;
}
.sa-dose-check-divider {
  height: 1px;
  background: #e5e7eb;
  margin: 16px 0;
}
.sa-dose-check-allowed {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px dashed #d1d5db;
  padding-top: 10px;
  margin: 4px 0 12px;
  font-size: 13px;
  color: #6b7280;
}
.sa-dose-check-allowed strong {
  color: #1a1a1a;
  font-weight: 700;
}
.sa-dose-check-banner {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.4;
}
.sa-dose-check-banner.is-ok {
  background: #e8f5e9;
  color: #2e7d32;
}
.sa-dose-check-banner.is-err {
  background: #ffebee;
  color: #c62828;
}
.sa-dose-check-icon {
  flex: 0 0 20px;
  margin-top: 1px;
  display: flex;
}
</style>